
define('inlineSvg!svgs/icon/expand-image', function () {return '<span class="inline-expand-image inline-icon"><svg width="22" height="22" viewBox="0 0 22 22"><path d="M3.4 20.2L9 14.5 7.5 13l-5.7 5.6L1 14H0v7.5l.5.5H8v-1l-4.6-.8M18.7 1.9L13 7.6 14.4 9l5.7-5.7.5 4.7h1.2V.6l-.5-.5H14v1.2l4.7.6"/></svg></span>';});

